import React from "react";
import styled from 'styled-components'

const InputComponent = ({ state, setState, type, placeholder, required }) => {
    return (
        <Input
            value={state}
            onChange={(e) => setState(e.target.value)}
            type={type}
            placeholder={placeholder}
            required={required}
            className="customInput"
        />
    );
};

export default InputComponent;

const Input = styled.input`
    background-color: var(--backgroundColor);
    color: var(--color);
    border: 0.1rem solid grey;
    border-radius: 0.25rem;
    padding: 1.25rem;
    font-size: 2rem;
    width: 40vw;
    font-weight: 500;
    margin: 0.8rem;
  
  &:focus {
    outline: none;
    border-color: var(--color);
  }
  
  &::placeholder {
    color: var(--color);
    font-size: 1.5rem;
  }
  


`